import { useIntl } from "react-intl";
import { useReportService } from "~pages/Reports/hooks/useReportService.ts";
import "./GenerateReportButton.scss";
import { Space, Typography } from "antd";

type Props = {
  titleIntlKey: string;
  descriptionIntlKey: string;
  url: string;
  notificationMessageIntlKey: string;
};
export const GenerateReportButton = ({ url, notificationMessageIntlKey, titleIntlKey, descriptionIntlKey }: Props) => {
  const { generateReport, isGeneratePending } = useReportService();
  const { formatMessage } = useIntl();

  return (
    <div
      className="report-button"
      style={{ opacity: isGeneratePending ? 0.7 : 1, pointerEvents: isGeneratePending ? "none" : undefined }}
      onClick={() => void generateReport(url, notificationMessageIntlKey)}
    >
      <Space direction={"vertical"} size={6}>
        <Space>
          <i className="fas fa-file-arrow-down"></i>
          <Typography.Title level={4} className="report-button-title">
            {formatMessage({ id: titleIntlKey })}
          </Typography.Title>
        </Space>
        <Typography style={{ fontSize: 12 }}>{formatMessage({ id: descriptionIntlKey })}</Typography>
      </Space>
    </div>
  );
};
